import { log } from '../../services/utils';

import { controller } from '../../contexts/AgenciesContext';

import { noraApiRequest } from './';

export const getAgencyList = async () => {
	log( '* get agency list' );
	// const { data } = await noraMockApiRequest( { url: '/agencies/search' } );
	const { data } = await noraApiRequest( {
		url: '/agencies',
		signal: controller.signal
	} );

	return data;
};

export const getAgency = async id => {
	log( '* get agency' );
	const { data } = await noraApiRequest( {
		url: `/agencies/${ id }`,
		signal: controller.signal
	} );

	return data;
};

export const createAgency = async data => {
	log( '* create agency' );
	const response = await noraApiRequest( {
		method: 'POST',
		url: '/agencies',
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const updateAgency = async data => {
	log( '* update agency' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: '/agencies',
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const deleteAgency = async id => {
	log( '* delete agency' );
	const response = await noraApiRequest( {
		method: 'DELETE',
		url: `/agencies/${ id }`,
		signal: controller.signal
	} );

	return response.data;
};

export const updateAgencyPhoto = async ( id, photoId ) => {
	log( '* update agency photo' );
	const response = await noraApiRequest( {
		method: 'PATCH',
		url: `/agencies/${ id }/photo/${ photoId }`,
		signal: controller.signal
	} );

	return response.data;
};

/* staff */

export const getAgencyStaffList = async agencyId => {
	log( '* get agency staff list' );
	const { data } = await noraApiRequest( {
		url: `agencies/${ agencyId }/staff`,
		signal: controller.signal
	} );

	return data;
};

export const getAgencyStaff = async ( agencyId, id, signal = controller.signal ) => {
	log( '* get agency staff' );
	const { data } = await noraApiRequest( {
		url: `agencies/${ agencyId }/staff/${ id }`,
		signal
	} );

	return data;
};

export const createAgencyStaff = async ( agencyId, data ) => {
	log( '* create agency staff' );
	const response = await noraApiRequest( {
		method: 'POST',
		url: `/agencies/${ agencyId }/staff`,
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const updateAgencyStaff = async ( agencyId, data ) => {
	log( '* update agency staff' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: `/agencies/${ agencyId }/staff`,
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const activateStaff = async ( agencyId, id ) => {
	log( '* activate staff' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: `/agencies/${ agencyId }/staff/${ id }/activate`,
		signal: controller.signal
	} );

	return response.data;
};

export const deactivateStaff = async ( agencyId, id ) => {
	log( '* deactivate staff' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: `/agencies/${ agencyId }/staff/${ id }/deactivate`,
		signal: controller.signal
	} );

	return response.data;
};

export const updateAgencyStaffPhoto = async ( id, photoId ) => {
	log( '* update agency staff photo' );
	const response = await noraApiRequest( {
		method: 'PATCH',
		url: `/contacts/${ id }/photo/${ photoId }`,
		signal: controller.signal
	} );

	return response.data;
};

/* coordination */

export const getCoordinationList = async agencyID => {
	log( '* get agency coordination list' );
	const { data } = await noraApiRequest( {
		url: `/agencies/${ agencyID }/coordination`,
		signal: controller.signal
	} );

	return data;
};

export const assignCoordination = async ( agencyID, data ) => {
	log( '* assign agency coordination' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: `/agencies/${ agencyID }/coordination/assign`,
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const unassignCoordination = async ( agencyID, coordinationID ) => {
	log( '* unassign agency coordination' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: `/agencies/${ agencyID }/coordination/unassign/${ coordinationID }`,
		signal: controller.signal
	} );

	return response.data;
};

/* locations */

export const getAgencyLocationList = async agencyID => {
	log( '* get agency location list' );
	const { data } = await noraApiRequest( {
		url: `/agencies/${ agencyID }/locations`,
		signal: controller.signal
	} );

	return data;
};

export const getAgencyLocation = async ( agencyID, id ) => {
	log( '* get agency location' );
	const { data } = await noraApiRequest( {
		url: `/agencies/${ agencyID }/location/${ id }`,
		signal: controller.signal
	} );

	return data;
};

export const createAgencyLocation = async ( agencyID, data ) => {
	log( '* create agency location' );
	const response = await noraApiRequest( {
		method: 'PATCH',
		url: `/agencies/${ agencyID }/location`,
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const deleteAgencyLocation = async ( agencyID, id ) => {
	log( '* create agency location' );
	const response = await noraApiRequest( {
		method: 'DELETE',
		url: `/agencies/${ agencyID }/location/${ id }`,
		signal: controller.signal
	} );

	return response.data;
};

export const exportAgencyList = async ids => {
	log( '* export agency list' );

	const response = await noraApiRequest( {
		method: 'POST',
		url: '/agencies/export',
		data: { ids },
		signal: controller.signal
	} );

	return response.data;
};
